import { FC, ReactElement } from 'react';
import { Badge } from 'react-bootstrap';

type StatusBadgeProps = {
  isActive: boolean;
  label: string;
};

const StatusBadge: FC<StatusBadgeProps> = ({ isActive, label }: StatusBadgeProps): ReactElement => {
  return (
    <Badge pill className={`fw-semibold ${isActive ? 'badge-bg-info' : 'badge-bg-danger'}`}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
